import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

// material-ui
import { Box, ClickAwayListener, Divider, Fade, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Paper, Popper, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// third-party
import PerfectScrollbar from "react-perfect-scrollbar";

// project imports
import MainCard from "ui-component/cards/MainCard";

// assets
import { IconBuilding, IconLogout, IconQrcode, IconSettings } from "@tabler/icons";
import QRGeneratorDialog from "components/QRGenerator";
import { useNegocioContext } from "contexts/NegocioContext";
import useConfig from "hooks/useConfig";

// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = () => {
  const theme = useTheme();
  const { borderRadius } = useConfig();
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(-1);
  // const { logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [qrDialogOpen, setQrDialogOpen] = useState(false);
  const { negocio } = useNegocioContext();
  /**
   * anchorRef is used on different components and specifying one type leads to other components throwing an error
   * */
  const anchorRef = useRef(null);
  const handleLogout = async () => {
    try {
      localStorage.clear();
      navigate("/login");
    } catch (err) {
      console.error(err);
    }
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  const handleListItemClick = (event, index, route = "") => {
    setSelectedIndex(index);
    handleClose(event);

    if (index === NAV_INDICES.GENERADOR_QR) {
      setQrDialogOpen(true);
      return;
    }

    if (route && route !== "") {
      navigate(route);
    }
  };
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const NAV_INDICES = {
    SUCURSALES: 1,
    CONFIGURACION: 2,
    CONFIGURACION_AVANZADA: 3,
    GENERADOR_QR: 4,
    CERRAR_SESION: 5,
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        aria-controls={open ? "profile-menu" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        sx={{
          background: theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[100],
          border: `1px solid ${theme.palette.divider}`,

          width: 44,
          height: 44,
          "&:hover": {
            background: theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[200],
            transform: "scale(1.05)",
          },
          transition: "all 0.2s ease-in-out",
        }}>
        <IconSettings stroke={1.5} size="1.3rem" color={theme.palette.text.primary} />
      </IconButton>

      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 8],
              },
            },
          ],
        }}>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={200}>
            <Paper
              sx={{
                border: `1px solid ${theme.palette.divider}`,
                boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
                minWidth: 220,
                backgroundColor: theme.palette.background.paper,
              }}>
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard border={false} elevation={0} content={false}>
                  <Box sx={{ p: 2 }}>
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="h6" color="textPrimary" fontWeight={600}>
                        {negocio?.nombre || "Panel de Control"}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Configuración del sistema
                      </Typography>
                    </Box>
                    <Divider />
                  </Box>
                  {/* <Box sx={{ p: 2, pb: 0 }}>
                                            <Stack>
                                                <Stack direction="row" spacing={0.5} alignItems="center">
                                                    <Typography variant="h4">Good Morning,</Typography>
                                                    <Typography component="span" variant="h4" sx={{ fontWeight: 400 }}>
                                                        {user?.name}
                                                    </Typography>
                                                </Stack>
                                                <Typography variant="subtitle2">Project Admin</Typography>
                                            </Stack>
                                            <OutlinedInput
                                                sx={{ width: '100%', pr: 1, pl: 2, my: 2 }}
                                                id="input-search-profile"
                                                value={value}
                                                onChange={(e) => setValue(e.target.value)}
                                                placeholder="Search profile options"
                                                startAdornment={
                                                    <InputAdornment position="start">
                                                        <IconSearch stroke={1.5} size="1rem" color={theme.palette.grey[500]} />
                                                    </InputAdornment>
                                                }
                                                aria-describedby="search-helper-text"
                                                inputProps={{
                                                    'aria-label': 'weight'
                                                }}
                                            />
                                            <Divider />
                                        </Box> */}
                  <PerfectScrollbar style={{ height: "100%", maxHeight: "calc(100vh - 250px)", overflowX: "hidden" }}>
                    <Box sx={{ p: 2, pt: 0 }}>
                      {/* <UpgradePlanCard /> */}
                      <Divider />
                      {/* <Card
                                                    sx={{
                                                        bgcolor:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.dark[800]
                                                                : theme.palette.primary.light,
                                                        my: 2
                                                    }}
                                                >
                                                    <CardContent>
                                                        <Grid container spacing={3} direction="column">
                                                            <Grid item>
                                                                <Grid item container alignItems="center" justifyContent="space-between">
                                                                    <Grid item>
                                                                        <Typography variant="subtitle1">Start DND Mode</Typography>
                                                                    </Grid>
                                                                    <Grid item>
                                                                        <Switch
                                                                            color="primary"
                                                                            checked={sdm}
                                                                            onChange={(e) => setSdm(e.target.checked)}
                                                                            name="sdm"
                                                                            size="small"
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item>
                                                                <Grid item container alignItems="center" justifyContent="space-between">
                                                                    <Grid item>
                                                                        <Typography variant="subtitle1">Allow Notifications</Typography>
                                                                    </Grid>
                                                                    <Grid item>
                                                                        <Switch
                                                                            checked={notification}
                                                                            onChange={(e) => setNotification(e.target.checked)}
                                                                            name="sdm"
                                                                            size="small"
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </CardContent>
                                                </Card> */}
                      <Divider />
                      <List
                        component="nav"
                        sx={{
                          width: "100%",
                          maxWidth: 350,
                          minWidth: 300,
                          backgroundColor: theme.palette.background.paper,
                          borderRadius: "10px",
                          [theme.breakpoints.down("md")]: {
                            minWidth: "100%",
                          },
                          "& .MuiListItemButton-root": {
                            mt: 0.5,
                          },
                        }}>
                        {/* <ListItemButton
                                                        sx={{ borderRadius: `${borderRadius}px` }}
                                                        selected={selectedIndex === 0}
                                                        onClick={(event) => handleListItemClick(event, 0, '/user/account-profile/profile1')}
                                                    >
                                                        <ListItemIcon>
                                                            <IconSettings stroke={1.5} size="1.3rem" />
                                                        </ListItemIcon>
                                                        <ListItemText primary={<Typography variant="body2">Account Settings</Typography>} />
                                                    </ListItemButton> */}
                        {negocio.rol === "ADMIN" && (
                          <>
                            <ListItemButton
                              sx={{ borderRadius: `${borderRadius}px` }}
                              selected={selectedIndex === NAV_INDICES.SUCURSALES}
                              onClick={(event) => handleListItemClick(event, NAV_INDICES.SUCURSALES, "/negocio/sucursales")}>
                              <ListItemIcon>
                                <IconBuilding stroke={1.5} size="1.3rem" />
                              </ListItemIcon>
                              <ListItemText primary={<Typography variant="body2">Sucursales</Typography>} />
                            </ListItemButton>
                            <ListItemButton
                              sx={{ borderRadius: `${borderRadius}px` }}
                              selected={selectedIndex === NAV_INDICES.CONFIGURACION}
                              onClick={(event) => handleListItemClick(event, NAV_INDICES.CONFIGURACION, "/negocio/configuracion")}>
                              <ListItemIcon>
                                <IconSettings stroke={1.5} size="1.3rem" />
                              </ListItemIcon>
                              <ListItemText primary={<Typography variant="body2">Configuración del Negocio</Typography>} />
                            </ListItemButton>
                            <ListItemButton
                              sx={{ borderRadius: `${borderRadius}px` }}
                              selected={selectedIndex === NAV_INDICES.CONFIGURACION_AVANZADA}
                              onClick={(event) => handleListItemClick(event, NAV_INDICES.CONFIGURACION_AVANZADA, "/negocio/configuracion-avanzada")}>
                              <ListItemIcon>
                                <IconSettings stroke={1.5} size="1.3rem" />
                              </ListItemIcon>
                              <ListItemText primary={<Typography variant="body2">Configuración Avanzada</Typography>} />
                            </ListItemButton>
                          </>
                        )}

                        {/* <ListItemButton
                                                        sx={{ borderRadius: `${borderRadius}px` }}
                                                        selected={selectedIndex === 2}
                                                        onClick={(event) => handleListItemClick(event, 2, '/user/social-profile/posts')}
                                                    >
                                                        <ListItemIcon>
                                                            <IconUser stroke={1.5} size="1.3rem" />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={
                                                                <Grid container spacing={1} justifyContent="space-between">
                                                                    <Grid item>
                                                                        <Typography variant="body2">Social Profile</Typography>
                                                                    </Grid>
                                                                    <Grid item>
                                                                        <Chip
                                                                            label="02"
                                                                            size="small"
                                                                            sx={{
                                                                                bgcolor:
                                                                                    theme.palette.mode === 'dark'
                                                                                        ? theme.palette.dark.dark
                                                                                        : theme.palette.warning.dark,
                                                                                color: theme.palette.background.default
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            }
                                                        />
                                                    </ListItemButton> */}
                        {/* Generador de QR - disponible para todos los roles */}
                        <ListItemButton
                          sx={{ borderRadius: `${borderRadius}px` }}
                          selected={selectedIndex === NAV_INDICES.GENERADOR_QR}
                          onClick={(event) => handleListItemClick(event, NAV_INDICES.GENERADOR_QR)}>
                          <ListItemIcon>
                            <IconQrcode stroke={1.5} size="1.3rem" />
                          </ListItemIcon>
                          <ListItemText primary={<Typography variant="body2">Generador de QR</Typography>} />
                        </ListItemButton>

                        <ListItemButton sx={{ borderRadius: `${borderRadius}px` }} selected={selectedIndex === NAV_INDICES.CERRAR_SESION} onClick={handleLogout}>
                          <ListItemIcon>
                            <IconLogout stroke={1.5} size="1.3rem" />
                          </ListItemIcon>
                          <ListItemText primary={<Typography variant="body2">Cerrar Sesion</Typography>} />
                        </ListItemButton>
                      </List>
                    </Box>
                  </PerfectScrollbar>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>

      {/* Diálogo del Generador de QR */}
      <QRGeneratorDialog open={qrDialogOpen} onClose={() => setQrDialogOpen(false)} />
    </>
  );
};

export default ProfileSection;
